export default __webpack_public_path__ + "1452d44211cecdacc5209549f0dca7b3.svg";